export const MARLEA = {
  // Nav
  navLogo: "nav-logo",
  navLinkWat: "nav-link-wat-doet-het",
  navLinkVoorWie: "nav-link-voor-wie",
  navLinkPakketten: "nav-link-pakketten",
  navCtaDemo: "nav-cta-demo",
  navMobileToggle: "nav-mobile-toggle",

  // Hero
  heroBadge: "hero-badge",
  heroHeadline: "hero-headline",
  heroSubheadline: "hero-subheadline",
  heroBenefit: (i) => `hero-benefit-${i}`,
  heroPrimaryCta: "hero-primary-cta",
  heroSecondaryCta: "hero-secondary-cta",
  heroTrust: "hero-trust",

  // Mockup
  mockupCard: "chatbot-mockup-card",
  leadCard: "warm-lead-card",

  // Features
  featureCard: (i) => `feature-card-${i}`,

  // Comparison
  comparisonForm: "comparison-card-form",
  comparisonAi: "comparison-card-ai",

  // Packages
  packageCard: (slug) => `package-card-${slug}`,
  packagesCta: "packages-cta",

  // Modal / Intake form
  intakeModal: "intake-modal",
  intakeClose: "intake-modal-close",
  intakeTitle: "intake-modal-title",
  intakeInputNaam: "intake-input-naam",
  intakeInputEmail: "intake-input-email",
  intakeInputTelefoon: "intake-input-telefoon",
  intakeInputBedrijf: "intake-input-bedrijf",
  intakeInputWebsite: "intake-input-website",
  intakeInputSector: "intake-input-sector",
  intakeSelectAanvragen: "intake-select-aanvragen",
  intakeSelectKlantwaarde: "intake-select-klantwaarde",
  intakeSelectVerbeterdoel: "intake-select-verbeterdoel",
  intakeSelectHuidigeBot: "intake-select-huidige-bot",
  intakeInputToelichting: "intake-input-toelichting",
  intakeSubmit: "intake-submit",
  intakeThanks: "intake-thanks",

  // Footer
  footer: "site-footer",
};
